@for (entry of entries(); track entry.key) {
  @if (entry.branch !== undefined) {
    <div class="tree-group">
      <div class="tree-group__key">{{ entry.key }}</div>
      <app-json-tree
        class="tree-group__children"
        [value]="entry.branch"
      ></app-json-tree>
    </div>
  } @else {
    <div class="tree-row" [class.tree-row--block]="entry.multiline">
      <div class="tree-row__key">{{ entry.key }}</div>

      @if (entry.multiline) {
        <pre class="tree-row__block">{{ entry.text }}</pre>
      } @else {
        <div class="tree-row__value">{{ entry.text }}</div>
      }
    </div>
  }
}
